import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { brandLogo } from '../brand/theme';
import { getToken } from '../utils/Common';
import './HomeLanding.css';

export default function Home(props) {
  useEffect(() => {
    if (getToken()) {
      props.history.push('/dashboard');
    }
  }, [props.history]);

  if (getToken()) {
    return null;
  }

  return (
    <div className="home-page">
      <div className="home-page-hero">
        <img src={brandLogo} alt="Bedrock Wireless" className="home-page-logo" />
        <h1 className="home-page-title">Wireless Construction Cameras</h1>
        <p className="home-page-tagline">
          Purpose-built for the jobsite — live view, timelapse, smart detection, and
          real-time alerts without the hassle of DIY setups.
        </p>
        <div className="home-page-actions">
          <Link to="/login" className="btn btn-brand-dark btn-compact">
            Log In
          </Link>
          <Link to="/signup" className="btn btn-brand-outline btn-compact">
            Create Account
          </Link>
        </div>
      </div>

      <div className="home-page-features">
        <span>Live View + Timelapse</span>
        <span className="home-page-features-sep">|</span>
        <span>Smart Detection</span>
        <span className="home-page-features-sep">|</span>
        <span>Real-time Alerts</span>
      </div>
    </div>
  );
}
